
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("41hSr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea2c0c6c3d35e10f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fIYpC = parcelRequire("fIYpC");
var $ea2c0c6c3d35e10f$export$2e2bcd8739ae039 = (0, $fIYpC.default);

});
parcelRegister("fIYpC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee1a9c3a31d03de6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $ee1a9c3a31d03de6$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "Team \u2022 50+ members",
    'fabric.elements.mentions.team.member.50plus.including.you': "Team \u2022 50+ members, including you",
    'fabric.elements.mentions.team.member.count': "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
    'fabric.elements.mentions.team.member.count.including.you': "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
    'fabric.elements.mentions.xproduct.mention.description': 'Needs access to Confluence',
    'fabric.mention.error.defaultAction': 'Try again in a few seconds',
    'fabric.mention.error.defaultHeadline': 'Something went wrong',
    'fabric.mention.error.differentText': 'Try entering different text',
    'fabric.mention.error.loginAgain': 'Try logging out then in again',
    'fabric.mention.noAccess.label': 'No access',
    'fabric.mention.noAccess.warning': "{name} won't be notified as they have no access",
    'fabric.mention.unknow.user.error': 'Unknown user {userId}'
};

});



//# sourceMappingURL=@atlaskit-internal_mention-i18n-en.653b9fda.js.map
